import { Component } from "@angular/core";

@Component({
    selector: "app-db-unavailable",
    templateUrl: "./db-unavailable.component.html",
    styleUrls: ["./db-unavailable.component.scss"],
    standalone: false
})
export class DBUnavailableComponent {}
